/**
 * VULTURE STUDIOS — Brand JS
 * Sticky header transparency, micro-interactions
 */

(function () {
  'use strict';

  // ─── HEADER SCROLL TRANSPARENCY ───────────────────────────────
  function initHeaderScroll() {
    var headerWrapper = document.querySelector('.header-wrapper');
    if (!headerWrapper) return;

    var threshold = 60;

    function onScroll() {
      if (window.scrollY > threshold) {
        headerWrapper.classList.add('vs-scrolled');
      } else {
        headerWrapper.classList.remove('vs-scrolled');
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll(); // run once on load
  }

  // ─── PRODUCT PAGE: ADD LIMITED DROP NOTICE ────────────────────
  function initLimitedNotice() {
    var submitBtn = document.querySelector('.product-form__submit');
    if (!submitBtn) return;

    var existing = document.querySelector('.vs-limited-notice');
    if (existing) return;

    var notice = document.createElement('span');
    notice.className = 'vs-limited-notice';
    notice.textContent = 'LIMITED DROP. NO RESTOCK.';
    submitBtn.parentNode.insertAdjacentElement('afterend', notice);
  }

  // ─── ANNOUNCEMENT MARQUEE DUPLICATION (for seamless loop) ─────
  function initMarquees() {
    document.querySelectorAll('.vs-announcement__track, .vs-marquee-strip__track').forEach(function (track) {
      // Already duplicated check
      if (track.dataset.vsInit) return;
      track.dataset.vsInit = '1';
    });
  }

  // ─── PAGE OFFSET FOR FIXED HEADER ─────────────────────────────
  function initPageOffset() {
    var header = document.querySelector('.section-header');
    if (!header) return;

    function updateOffset() {
      var h = header.offsetHeight;
      document.documentElement.style.setProperty('--vs-header-height', h + 'px');
      var firstSection = document.querySelector('#MainContent > .shopify-section:first-child');
      if (firstSection) {
        // Hero section handles its own full-height, no padding needed
        // For non-hero pages, offset content
        if (!firstSection.querySelector('.vs-hero')) {
          document.getElementById('MainContent').style.paddingTop = h + 'px';
        }
      }
    }

    window.addEventListener('resize', updateOffset, { passive: true });
    updateOffset();
  }

  // ─── CART: WHATSAPP VALIDATION ────────────────────────────────
  function initWhatsAppValidation() {
    var input = document.getElementById('vs-whatsapp-input');
    var errorEl = document.getElementById('vs-whatsapp-error');
    if (!input) return;

    // The cart form (defined in main-cart-items) has id="cart"
    var cartForm = document.getElementById('cart');

    function showError(msg) {
      errorEl.textContent = msg;
      input.classList.add('vs-whatsapp-field__input--error');
    }

    function clearError() {
      errorEl.textContent = '';
      input.classList.remove('vs-whatsapp-field__input--error');
    }

    function validate() {
      var val = input.value.replace(/\s/g, '');
      if (val === '') {
        showError('WhatsApp number is required — we confirm all orders via WhatsApp before shipping');
        return false;
      }
      if (!val.startsWith('01')) {
        showError('Number must start with 01 (e.g. 01XXXXXXXXX)');
        return false;
      }
      if (val.length !== 11) {
        showError('Must be exactly 11 digits (01XXXXXXXXX) — you entered ' + val.length);
        return false;
      }
      if (!/^\d{11}$/.test(val)) {
        showError('Numbers only — no spaces, dashes or letters');
        return false;
      }
      clearError();
      return true;
    }

    // Always re-validate on every keystroke so errors update in real time
    input.addEventListener('input', validate);

    // Intercept the form submit — catches button click, Enter key, everything
    if (cartForm) {
      cartForm.addEventListener('submit', function (e) {
        // Only block when the submit is headed to checkout (name=checkout button)
        // Cart update (name=update) should still work normally
        var submitter = e.submitter;
        var isCheckout = !submitter || submitter.name === 'checkout' || submitter.id === 'checkout';
        if (isCheckout && !validate()) {
          e.preventDefault();
          e.stopImmediatePropagation();
          input.focus();
          input.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, true); // capture phase — runs before Dawn's own submit handlers
    }

    // Belt-and-suspenders: also catch the checkout button directly
    var checkoutBtn = document.getElementById('checkout');
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function (e) {
        if (!validate()) {
          e.preventDefault();
          e.stopImmediatePropagation();
          input.focus();
          input.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, true);
    }
  }

  // ─── PRODUCT PAGE ACCORDIONS ───────────────────────────────────
  function initAccordions() {
    document.querySelectorAll('.vs-accordion__header').forEach(function (btn) {
      if (btn.dataset.vsInit) return;
      btn.dataset.vsInit = '1';

      btn.addEventListener('click', function () {
        var accordion = btn.closest('.vs-accordion');
        var body = accordion.querySelector('.vs-accordion__body');
        var icon = btn.querySelector('.vs-accordion__icon');
        var isOpen = btn.getAttribute('aria-expanded') === 'true';

        if (isOpen) {
          btn.setAttribute('aria-expanded', 'false');
          icon.textContent = '+';
          body.setAttribute('hidden', '');
          accordion.classList.remove('vs-accordion--open');
        } else {
          btn.setAttribute('aria-expanded', 'true');
          icon.textContent = '−';
          body.removeAttribute('hidden');
          accordion.classList.add('vs-accordion--open');
        }
      });
    });
  }

  // ─── INIT ──────────────────────────────────────────────────────
  function init() {
    initHeaderScroll();
    initMarquees();
    initPageOffset();

    // DOM-dependent inits
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initLimitedNotice();
        initAccordions();
        initWhatsAppValidation();
      });
    } else {
      initLimitedNotice();
      initAccordions();
      initWhatsAppValidation();
    }
  }

  init();
})();

// // ─── CART SHIPPING BAR LIVE UPDATE ───────────────────────────
// (function () {
//   var THRESHOLD = 130000; // 1300 EGP in cents

//   function updateBar(totalCents) {
//     var textEl = document.getElementById('vs-cart-bar-text');
//     var fillEl = document.getElementById('vs-cart-bar-fill');
//     if (!textEl || !fillEl) return;
//     var pct = Math.min(100, Math.round((totalCents / THRESHOLD) * 100));
//     fillEl.style.width = pct + '%';
//     if (totalCents >= THRESHOLD) {
//       textEl.innerHTML = '<span class="vs-cart-bar__unlocked">FREE SHIPPING UNLOCKED</span>';
//     } else {
//       var remaining = Math.ceil((THRESHOLD - totalCents) / 100);
//       textEl.innerHTML = 'Add <strong>' + remaining + ' EGP</strong> to unlock <strong>FREE SHIPPING</strong>';
//     }
//   }

//   function fetchAndUpdate() {
//     fetch('/cart.js')
//       .then(function (r) { return r.json(); })
//       .then(function (d) { updateBar(d.total_price); })
//       .catch(function () { });
//   }

//   // Dawn fires this event after cart sections re-render
//   document.addEventListener('cart:refresh', fetchAndUpdate);

//   // Watch the cart total value for DOM changes (Dawn updates it in place)
//   document.addEventListener('DOMContentLoaded', function () {
//     var totalsEl = document.querySelector('.totals__total-value');
//     if (totalsEl) {
//       new MutationObserver(fetchAndUpdate).observe(totalsEl, { childList: true, subtree: true, characterData: true });
//     }
//     fetchAndUpdate();
//   });
// })();

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.vs-product-card--has-hover').forEach(function (card) {
    var imgs = card.dataset.imgs ? card.dataset.imgs.split(',') : [];
    if (imgs.length < 2) return;

    var staticImg = card.querySelector('.vs-card__static');
    if (!staticImg) return;

    var defaultSrc = imgs[0];
    var timer = null;
    var idx = 0;

    // preload all images for smooth cycling
    imgs.forEach(function (src) {
      var pre = new Image(); pre.src = src;
    });

    function startCycle() {
      idx = 1;
      staticImg.src = imgs[idx];
      timer = setInterval(function () {
        idx = (idx + 1) % imgs.length;
        staticImg.src = imgs[idx];
      }, 750);
    }

    function stopCycle() {
      clearInterval(timer);
      timer = null;
      idx = 0;
      staticImg.src = defaultSrc;
    }

    card.addEventListener('mouseenter', startCycle);
    card.addEventListener('mouseleave', stopCycle);

    // mobile: tap once → auto-cycle through all images, stop at last
    card.addEventListener('touchstart', function (e) {
      e.stopPropagation();
      if (timer) return; // already cycling
      idx = 1;
      staticImg.src = imgs[idx];
      timer = setInterval(function () {
        idx++;
        if (idx >= imgs.length) {
          clearInterval(timer);
          timer = null;
          return;
        }
        staticImg.src = imgs[idx];
      }, 750);
    }, { passive: true });
  });
});
// ─── WATCHING COUNT ───────────────────────────────────────────
(function () {
  var el = document.getElementById('vs-watching-count');
  if (el) {
    el.textContent = Math.floor(Math.random() * 16) + 25;
  }
})();

// ─── CART QUICK ADD ───────────────────────────────────
// ─── UPSELL SIZE PICKER ───────────────────────────────────────
document.addEventListener('click', function (e) {
  var sizeBtn = e.target.closest('.vs-upsell-size');
  if (!sizeBtn) return;
  var control = sizeBtn.closest('.vs-upsell-control');
  control.querySelectorAll('.vs-upsell-size').forEach(function (b) {
    b.classList.remove('vs-upsell-size--active');
  });
  sizeBtn.classList.add('vs-upsell-size--active');
  control.querySelector('.vs-upsell-stepper__qty').textContent = '0';
});

// ─── UPSELL STEPPER ───────────────────────────────────────────
function vsUpsellChange(btn, delta) {
  var control = btn.closest('.vs-upsell-control');
  var qtyEl = control.querySelector('.vs-upsell-stepper__qty');
  var current = parseInt(qtyEl.textContent) || 0;
  var activeSize = control.querySelector('.vs-upsell-size--active');
  if (!activeSize) return;
  var variantId = parseInt(activeSize.dataset.variantId);

  console.log('=== UPSELL DEBUG ===');
  console.log('delta:', delta);
  console.log('variantId:', variantId);
  console.log('current stepper qty:', current);
  console.log('active size button text:', activeSize.textContent.trim());

  if (delta === 1) {
    fetch('/cart/add.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        console.log('cart/add response:', JSON.stringify(response));
        qtyEl.textContent = current + 1;
        if (current + 1 > 0) {
          var card = control.closest('.vs-cart-upsell__card');
          if (card) card.style.display = 'none';
        }
        vsRefreshCartAndBar();
      })
      .catch(function (err) {
        console.log('cart/add ERROR:', err);
      });
  }
}
// ─── REFRESH CART DRAWER + BAR ────────────────────────────────
function vsRefreshCartAndBar() {
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      // update header count
      var countEl = document.querySelector('.cart-count-bubble span');
      if (countEl) countEl.textContent = cart.item_count;

      // update shipping bar
      var barText = document.getElementById('vs-cart-bar-text');
      var barFill = document.getElementById('vs-cart-bar-fill');
      if (barText && barFill) {
        var pct = Math.min(100, Math.round((cart.total_price / 130000) * 100));
        barFill.style.width = pct + '%';
        if (cart.total_price >= 130000) {
          barText.innerHTML = '<span class="vs-cart-bar__unlocked">FREE SHIPPING UNLOCKED 🎉</span>';
        } else {
          var rem = Math.ceil((130000 - cart.total_price) / 100);
          barText.innerHTML = 'Add <strong>' + rem + ' EGP</strong> to unlock <strong>FREE SHIPPING</strong>';
        }
      }
      // update bar labels
      var currentLabel = document.getElementById('vs-cart-bar-current');
      var goalLabel = document.getElementById('vs-cart-bar-goal');
      if (currentLabel) currentLabel.textContent = Math.round(cart.total_price / 100) + ' EGP';
      if (goalLabel) goalLabel.textContent = '1300 EGP';
      // update estimated total
      var totalEl = document.querySelector('.totals__total-value');
      if (totalEl) {
        totalEl.textContent = (cart.total_price / 100).toLocaleString('en-EG', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }) + ' EGP';
      }

      // refresh cart drawer sections so items re-render
      fetch('/?sections=cart-drawer')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var drawerEl = document.getElementById('CartDrawer-CartItems');
          if (drawerEl && data['cart-drawer']) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(data['cart-drawer'], 'text/html');
            var newItems = doc.getElementById('CartDrawer-CartItems');
            if (newItems) drawerEl.innerHTML = newItems.innerHTML;
          }
        });
    });
}

// ─── SIZE FINDER ──────────────────────────────────────────────────────────────
(function () {
  var state = { gender: null, height: null, weight: null, build: null, result: null };

  function open() {
    var overlay = document.getElementById('vs-sf-overlay');
    if (!overlay) return;
    overlay.classList.add('vs-sf-open');
    document.body.style.overflow = 'hidden';
    showStep(1);
  }

  function close() {
    var overlay = document.getElementById('vs-sf-overlay');
    if (overlay) overlay.classList.remove('vs-sf-open');
    document.body.style.overflow = '';
  }

  function showStep(n) {
    [1, 2, 3, 4].forEach(function (i) {
      var el = document.getElementById('vs-sf-step-' + i);
      if (el) el.hidden = (i !== n);
    });
    document.querySelectorAll('.vs-sf-dot').forEach(function (dot, i) {
      dot.classList.remove('vs-sf-dot--active', 'vs-sf-dot--done');
      if (i + 1 === n) dot.classList.add('vs-sf-dot--active');
      else if (i + 1 < n) dot.classList.add('vs-sf-dot--done');
    });
  }

  function selectGender(g) {
    state.gender = g;
    document.querySelectorAll('.vs-sf-gender-btn').forEach(function (btn) {
      btn.classList.toggle('vs-sf-gender-btn--active', btn.dataset.gender === g);
    });
    document.querySelectorAll('.vs-sf-build-set').forEach(function (set) {
      set.hidden = (set.dataset.gender !== g);
    });
    setTimeout(function () { showStep(2); }, 260);
  }

  function goToBuilds() {
    var h = parseInt(document.getElementById('vs-sf-height').value);
    var w = parseInt(document.getElementById('vs-sf-weight').value);
    var err = document.getElementById('vs-sf-meas-error');
    if (!h || h < 140 || h > 220) { err.textContent = 'Enter a valid height (140–220 cm)'; return; }
    if (!w || w < 35 || w > 180)  { err.textContent = 'Enter a valid weight (35–180 kg)'; return; }
    err.textContent = '';
    state.height = h;
    state.weight = w;
    showStep(3);
  }

  function selectBuild(b) {
    state.build = b;
    document.querySelectorAll('.vs-sf-build-btn').forEach(function (btn) {
      btn.classList.toggle('vs-sf-build-btn--active', btn.dataset.build === b);
    });
    setTimeout(calcAndShow, 320);
  }

  function recommend(gender, height, weight, build) {
    var size;
    if (gender === 'male') {
      if (weight >= 92) { size = 'L'; }
      else if (weight >= 78) { size = (height >= 182 || build === 'broad') ? 'L' : 'M'; }
      else if (weight >= 64) { size = (height >= 182 || build === 'broad') ? 'M' : 'S'; }
      else { size = (height >= 183 && build !== 'lean') ? 'M' : 'S'; }
    } else {
      if (weight >= 82) { size = 'L'; }
      else if (weight >= 67) { size = (height >= 168 || build === 'curvy') ? 'L' : 'M'; }
      else if (weight >= 52) { size = (height >= 172 || build === 'curvy') ? 'M' : 'S'; }
      else { size = (height >= 170 && build !== 'slim') ? 'M' : 'S'; }
    }
    return size;
  }

  function calcAndShow() {
    state.result = recommend(state.gender, state.height, state.weight, state.build);
    document.getElementById('vs-sf-result-size').textContent = state.result;
    var subs = { S: 'Best for a lean to medium frame', M: 'Best for a medium to athletic frame', L: 'Best for a broader or taller frame' };
    document.getElementById('vs-sf-result-sub').textContent = subs[state.result] || '';
    showStep(4);
  }

  function applySize() {
    if (!state.result) return;
    var size = state.result.toUpperCase();
    var found = false;
    // Radio buttons (pill picker)
    document.querySelectorAll('.product-form__input input[type="radio"]').forEach(function (input) {
      if (input.value.trim().toUpperCase() === size) { input.click(); found = true; }
    });
    // Dropdown fallback
    if (!found) {
      document.querySelectorAll('.product-form__input select').forEach(function (sel) {
        Array.from(sel.options).forEach(function (opt) {
          if (opt.value.trim().toUpperCase() === size) {
            sel.value = opt.value;
            sel.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
    }
    close();
    var picker = document.querySelector('.product-form__input--pill, .product-form__input--swatch');
    if (picker) picker.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  document.addEventListener('DOMContentLoaded', function () {
    // Move overlay to <body> so position:fixed isn't trapped inside
    // the product sticky column which has a CSS transform applied
    var overlay = document.getElementById('vs-sf-overlay');
    if (overlay) document.body.appendChild(overlay);

    var trigger = document.getElementById('vs-sf-trigger');
    if (trigger) trigger.addEventListener('click', open);

    var closeBtn = document.getElementById('vs-sf-close');
    if (closeBtn) closeBtn.addEventListener('click', close);

    var overlay = document.getElementById('vs-sf-overlay');
    if (overlay) overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });

    document.querySelectorAll('.vs-sf-gender-btn').forEach(function (btn) {
      btn.addEventListener('click', function () { selectGender(btn.dataset.gender); });
    });

    var nextMeas = document.getElementById('vs-sf-next-meas');
    if (nextMeas) nextMeas.addEventListener('click', goToBuilds);

    document.querySelectorAll('.vs-sf-build-btn').forEach(function (btn) {
      btn.addEventListener('click', function () { selectBuild(btn.dataset.build); });
    });

    var applyBtn = document.getElementById('vs-sf-apply');
    if (applyBtn) applyBtn.addEventListener('click', applySize);

    var retryBtn = document.getElementById('vs-sf-retry');
    if (retryBtn) retryBtn.addEventListener('click', function () {
      state = { gender: null, height: null, weight: null, build: null, result: null };
      document.querySelectorAll('.vs-sf-gender-btn').forEach(function (b) { b.classList.remove('vs-sf-gender-btn--active'); });
      document.querySelectorAll('.vs-sf-build-btn').forEach(function (b) { b.classList.remove('vs-sf-build-btn--active'); });
      showStep(1);
    });

    // Close on Escape
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  });
})();

// ─── BUNDLE OFFER POPUP ───────────────────────────────────────────────────────
(function () {
  if (sessionStorage.getItem('vs-popup-seen')) return;

  var html = [
    '<style>',
    '#vs-popup-overlay{position:fixed;inset:0;background:rgba(0,0,0,0.78);z-index:99999;display:flex;align-items:center;justify-content:center;padding:20px;}',
    '#vs-popup{background:#111111;border:1px solid #1a1a1a;max-width:480px;width:100%;padding:48px 40px;text-align:center;position:relative;}',
    '#vs-popup-close{position:absolute;top:16px;right:20px;background:none;border:none;color:#666!important;font-size:1.4rem;cursor:pointer;line-height:1;}',
    '#vs-popup-label{font-family:"Inter",sans-serif;font-size:0.7rem;letter-spacing:0.25em;color:#666!important;margin:0 0 12px;text-transform:uppercase;}',
    '#vs-popup-headline{font-family:"Bebas Neue",sans-serif;font-size:3rem;color:#e8e4dc!important;margin:0 0 8px;letter-spacing:0.05em;line-height:1.05;}',
    '#vs-popup-body{font-family:"Inter",sans-serif;font-size:0.85rem;color:#666!important;margin:0 0 32px;line-height:1.6;}',
    '#vs-popup-body strong{color:#e8e4dc!important;}',
    '#vs-popup-cta{display:block;font-family:"Bebas Neue",sans-serif;font-size:1rem;letter-spacing:0.2em;background:#e8e4dc;color:#080808!important;padding:16px 32px;text-decoration:none;margin-bottom:12px;}',
    '#vs-popup-cta:hover{background:#8b0000;color:#e8e4dc!important;}',
    '#vs-popup-dismiss{background:none;border:none;font-family:"Inter",sans-serif;font-size:0.75rem;color:#555!important;cursor:pointer;letter-spacing:0.1em;text-transform:uppercase;}',
    '</style>',
    '<div id="vs-popup-overlay">',
    '  <div id="vs-popup">',
    '    <button id="vs-popup-close">&#x2715;</button>',
    '    <p id="vs-popup-label">Drop 01 — Limited Offer</p>',
    '    <h2 id="vs-popup-headline">BOTH TEES.<br>999 EGP.</h2>',
    '    <p id="vs-popup-body">Get the EGO Tee + Deadly Desires Tee together.<br>Offer ends <strong>June 11</strong>. No restock.</p>',
    '    <a href="/products/ego-drop-bundle" id="vs-popup-cta">SHOP THE BUNDLE</a>',
    '    <button id="vs-popup-dismiss">No thanks</button>',
    '  </div>',
    '</div>'
  ].join('');

  function closePopup() {
    var overlay = document.getElementById('vs-popup-overlay');
    if (overlay) {
      overlay.style.opacity = '0';
      overlay.style.transition = 'opacity 0.3s';
      setTimeout(function () { if (overlay.parentNode) overlay.parentNode.removeChild(overlay); }, 300);
    }
    sessionStorage.setItem('vs-popup-seen', '1');
  }

  function showPopup() {
    document.body.insertAdjacentHTML('beforeend', html);
    var overlay = document.getElementById('vs-popup-overlay');
    overlay.style.opacity = '0';
    overlay.style.transition = 'opacity 0.3s';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { overlay.style.opacity = '1'; });
    });
    document.getElementById('vs-popup-close').addEventListener('click', closePopup);
    document.getElementById('vs-popup-dismiss').addEventListener('click', closePopup);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closePopup(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePopup(); });
  }

  var TARGET = 7000;
  var elapsed = (typeof performance !== 'undefined' && performance.now) ? performance.now() : 0;
  var delay = Math.max(0, TARGET - elapsed);
  // setTimeout(showPopup, delay);  // COMMENTED: popup disabled
})();